export const supportActionTypes = {
    
    /**
     * Support get section articles constants
     */
    GET_SECTION_ARTICLE_REQUEST: 'SUPPORT_GET_SECTION_ARTICLE_REQUEST',
    GET_SECTION_ARTICLE_SUCCESS: 'SUPPORT_GET_SECTION_ARTICLE_SUCCESS',
    GET_SECTION_ARTICLE_FAILURE: 'SUPPORT_GET_SECTION_ARTICLE_FAILURE',
    
};